import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Header } from './Header';
import { Footer } from './Footer';
import './Layout.scss';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const hideHeaderFooter =
    location.pathname === '/why-ai-university' ||
    location.pathname === '/home-v2';

  if (
    location.pathname === '/home-v2' ||
    location.pathname === '/discover-v2'
  ) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col">
      {!hideHeaderFooter && (
        <div>
          <Header />
        </div>
      )}
      <main className={`flex-1 ${isAuthenticated ? 'layout-authenticated' : ''}`}>{children}</main>
      {!hideHeaderFooter && !isAuthenticated && <Footer />}
    </div>
  );
};
